export const OtelOp = {
    RENDER: {
        name: 'plain_table_render',
        description: 'Time from grid ready to first data rendered',
    },
    DATA_UPDATE: {
        name: 'plain_table_data_update',
        description: 'Row data change cycle in the plain table',
    },
    ROW_HEIGHT_RESET: {
        name: 'plain_table_row_height_reset',
        description: 'Idle-callback row height recalculation cycle',
    },
};
//# sourceMappingURL=otel-operations.js.map